// extracted by mini-css-extract-plugin
module.exports = {"content":"ErrorMessage_content__nu7_V","mainImage":"ErrorMessage_mainImage__zeHAW","title":"ErrorMessage_title__d9rAM","description":"ErrorMessage_description__s67oO"};